@if (name) {
<span
  class="icon-component"
  [ngStyle]="{
    width: width,
    height: height,
    fill: fillColor,
    strokeColor: strokeColor
  }"
>
  <mat-icon [svgIcon]="name + (isActive ? '-active' : '')"></mat-icon>
</span>
}
